import { assert } from '@ember/debug';
import { scrollToElement } from './scrolling';
const OVERRIDE_CLASS_NAME = 'error-scrolling-override';
const FORM_GROUP_ERROR_SELECTOR = `.prism-form-group--has-error, market-field[invalid] [invalid], .${OVERRIDE_CLASS_NAME}`;
const ERROR_TOOLTIP_SELECTOR = '.prism-form-error-tooltip';
export const BUFFER_OFFSET = 16; // a little extra space above the field/tooltip

function focusInput(element) {
  element.querySelector('input, select, button, [data-error-focusable]').focus();
}
function scrollToPrismError(firstErrorElement, scrollable) {
  const firstErrorTooltipElement = firstErrorElement.querySelector(ERROR_TOOLTIP_SELECTOR);

  // Offset for error tooltip + a buffer.
  //
  // For this calculation to work the tooltip needs to be present in the DOM
  // even when not visible.
  const topOffset = firstErrorTooltipElement ? firstErrorTooltipElement.offsetHeight + BUFFER_OFFSET : BUFFER_OFFSET;
  return scrollToElement(firstErrorElement, scrollable, {
    topOffset
  }).catch(() => {}).finally(() => {
    if (firstErrorElement.className.includes(OVERRIDE_CLASS_NAME)) {
      firstErrorElement.focus();
    } else {
      focusInput(firstErrorElement);
    }
  });
}
function scrollToMarketError(firstErrorElement, scrollable) {
  return scrollToElement(firstErrorElement, scrollable, {
    topOffset: BUFFER_OFFSET
  }).catch(() => {}).finally(() => {
    if (firstErrorElement.nodeName.toLowerCase() === 'market-select' || firstErrorElement.className.includes(OVERRIDE_CLASS_NAME)) {
      firstErrorElement.focus();
    } else {
      focusInput(firstErrorElement.shadowRoot);
    }
  });
}

/**
 * Scrolls the page to the first errored form group. The error tooltip is
 * included in the viewport after the scrolling.
 *
 * @function scrollToFirstError
 * @param {HTMLElement} scrollable A HTMLElement representing a scrollable part
 * of the document
 * @returns {Promise}
 */
export function scrollToFirstError(scrollable) {
  assert('No element to scroll', scrollable instanceof HTMLElement);
  const firstErrorElement = scrollable.querySelector(FORM_GROUP_ERROR_SELECTOR);
  if (firstErrorElement) {
    if (firstErrorElement.nodeName.toLowerCase().startsWith('market')) {
      return scrollToMarketError(firstErrorElement, scrollable);
    } else {
      return scrollToPrismError(firstErrorElement, scrollable);
    }
  } else {
    // Provide a resolved promise so that this function returns a promise in
    // all cases.
    return new Promise(resolve => {
      resolve();
    });
  }
}

/**
 * Scrolls to non-form group error banner.
 *
 * @param {String} errorSelector - CSS selector of error banner
 * @param {String} scrollableSelector - CSS selector of scrollable element
 */
export function scrollToError(errorSelector, scrollableSelector) {
  if (document.querySelector(scrollableSelector)) {
    scrollToElement(document.querySelector(errorSelector), document.querySelector(scrollableSelector), {
      topOffset: BUFFER_OFFSET
    });
  }
}